import type { Adjustment } from '@app/shared/types/sf-data'

import { fetchAdjustments } from '@app/application/adjustments/api'

type AdjustmentsAndOrder = {
  adjustments: Record<string, Adjustment>
  adjustmentOrder: Array<number>
}

function transformAdjustments(
  adjustments: Adjustment[],
  checkedAdjustments?: Adjustment[]
): AdjustmentsAndOrder {
  return adjustments.reduce(
    (acc, adjustment) => {
      const categoryIds = adjustment.category === 'internal' ? 1 : 0

      const checked = checkedAdjustments
        ? checkedAdjustments.some(
            (checkedAdjustment) => checkedAdjustment.id === adjustment.id
          )
        : false

      const modifiedAdjustment = {
        ...adjustment,
        checked: checked,
        categoryIds: [categoryIds],
        copyTypes: [adjustment.originalAdjustmentType],
      }

      acc.adjustments[adjustment.id] = modifiedAdjustment
      acc.adjustmentOrder.push(adjustment.id)

      return acc
    },
    {
      adjustments: {},
      adjustmentOrder: [],
    } as AdjustmentsAndOrder
  )
}

export async function fetchAdjustmentsAndOrderBatch(
  copyType: 'reverse' | 'forward' | 'normal',
  page: number,
  ledgerId: number,
  accountId: number | undefined,
  checkedAdjustments?: Adjustment[]
): Promise<AdjustmentsAndOrder> {
  const firmId = window.Silverfin.currentFirmId
  const companyId = window.Silverfin.currentCompanyId

  const options = {
    page: page,
    copy_type: copyType,
    forward_account_id: copyType === 'forward' ? accountId : undefined,
  }

  const adjustments = await fetchAdjustments({
    firmId,
    companyId,
    ledgerId,
    options,
  })

  if (adjustments) {
    return transformAdjustments(adjustments, checkedAdjustments)
  } else {
    return {
      adjustments: {},
      adjustmentOrder: [],
    }
  }
}
